import lazyPage from '@monorepo/core/hoc/lazyPage'

export default () => [
  {
    path: '/customer-catalog',
    component: lazyPage(() =>
      import('App/View/CustomerCatalog').then(
        ({ CustomerCatalog }) => CustomerCatalog
      )
    ),
    exact: true,
  },
]
